
import { Link, useNavigate } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';
import categories from '../products';
import heroImg from '../images/portretten/portretten_1A.png';
import placeholderImg from '../images/logo_jm_simpel.png';

// Dummy recensies, in een echte app zou je deze importeren of ophalen
const homepageRecensies = [
  { naam: 'Sanne', sterren: 5, tekst: 'Super service en prachtig resultaat!' },
  { naam: 'Tom', sterren: 4, tekst: 'Snelle levering en goed contact.' },
  { naam: 'Lisa', sterren: 5, tekst: 'Heel blij met mijn 3D-model, aanrader!' },
];

// Map van categorie-id naar afbeelding
const categoryImages = {
  kerken: require('../images/kerken/Kerk_1A.png'),
  skylines: require('../images/skylines/Skyline_2A.jpg'),
  plattegronden: require('../images/plattegronden/plattegrond_1A.png'),
  portretten: require('../images/portretten/portretten_1A.png'),
  relief: require('../images/relief/Relief_1A.png'),
  diverse: heroImg,
  fallback: placeholderImg,
};

export default function Home() {
  const [search, setSearch] = useState('');
  const [carouselIdx, setCarouselIdx] = useState(categories.map(() => 0)); // index per categorie
  const navigate = useNavigate();

  const handleSearch = (e) => {
    e.preventDefault();
    if (search.trim()) {
      navigate(`/categorie/portretten?zoek=${encodeURIComponent(search)}`); // evt. aanpassen voor echte zoekfunctie
    }
  };

  return (
    <div className="min-h-screen bg-gray-50" style={{ background: 'var(--color-bg)', color: 'var(--color-text)' }}>
      {/* Hero section */}
      <div className="relative section bg-white flex flex-col md:flex-row items-center justify-between rounded-2xl shadow-lg mb-12 overflow-hidden" style={{ minHeight: 320 }}>
        <div className="flex-1 p-4 sm:p-8 md:p-16">
          <h1 className="text-3xl sm:text-5xl font-extrabold mb-4 sm:mb-6 text-accent1" style={{ textShadow: '0 2px 8px #fff8' }}>Prints by Jeroen</h1>
          <p className="text-lg sm:text-2xl mb-6 sm:mb-8 max-w-2xl" style={{ color: 'var(--color-text)' }}>
            Op maat gemaakte 3D-designs: portretten, kerken, skylines, plattegronden en meer. Uniek, persoonlijk en met aandacht ontworpen. Perfect voor een persoonlijk cadeau, of een presentje voor jezelf.
          </p>
          <form onSubmit={handleSearch} className="w-full max-w-lg mb-6 sm:mb-8">
            <div className="relative">
              <input
                type="text"
                placeholder="Waar ben je naar op zoek?"
                value={search}
                onChange={e => setSearch(e.target.value)}
                className="input w-full pr-12 text-base sm:text-lg py-2 sm:py-3"
              />
              <button type="submit" className="absolute right-3 top-1/2 -translate-y-1/2 text-accent1">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-4.35-4.35m0 0A7.5 7.5 0 104.5 4.5a7.5 7.5 0 0012.15 12.15z" />
                </svg>
              </button>
            </div>
          </form>
          <Link to="/contact" className="btn-primary px-6 sm:px-8 py-3 sm:py-4 text-base sm:text-lg">Vraag direct uw ontwerp aan</Link>
        </div>
        <div className="flex-1 h-full min-h-[220px] sm:min-h-[320px] flex items-center justify-center">
          <img src={heroImg} alt="Prints by Jeroen" className="object-contain w-full h-auto max-h-[220px] sm:max-h-[400px]" style={{ borderRadius: '0 2rem 2rem 0', objectPosition: 'center' }} />
        </div>
      </div>
      {/* Categorieën grid */}
      <div className="container-custom section">
        <h2 className="text-2xl sm:text-3xl font-extrabold mb-6 sm:mb-8 text-center text-accent1">Categorieën</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 sm:gap-12">
          {categories.map((cat, idx) => {
            const products = cat.products || [];
            const current = carouselIdx[idx] || 0;
            const product = products[current] || {};
            const img = product.images && product.images[0] ? product.images[0] : (categoryImages[cat.id] || categoryImages.fallback);
            return (
              <div
                key={cat.id}
                className="product-card group hover:scale-105 transition-transform flex flex-col items-center text-center bg-white rounded-xl shadow p-4 sm:p-6"
                style={{ minHeight: 320, minWidth: 0, maxWidth: 440, margin: '0 auto' }}
              >
                {/* Carousel per product */}
                <div className="relative flex items-center justify-center w-full mb-4" style={{ height: 180 }}>
                  {/* Vorige knop */}
                  {products.length > 1 && (
                    <button
                      className="absolute left-0 z-10 bg-white/80 hover:bg-accent1 text-accent1 hover:text-white rounded-full p-2 shadow transition"
                      style={{ top: '50%', transform: 'translateY(-50%)' }}
                      onClick={e => {
                        e.stopPropagation();
                        setCarouselIdx(arr => arr.map((v, i) => i === idx ? (v - 1 + products.length) % products.length : v));
                      }}
                      aria-label="Vorige voorbeeld"
                    >
                      <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M15 19l-7-7 7-7" /></svg>
                    </button>
                  )}
                  {/* Alleen afbeelding klikbaar */}
                  <Link to={`/categorie/${cat.id}`} style={{ textDecoration: 'none' }}>
                    <img
                      src={img}
                      alt={product.name || cat.name}
                      className="object-contain rounded shadow transition-all duration-300 w-full max-w-[180px] h-[140px] sm:w-[220px] sm:h-[220px] cursor-pointer"
                    />
                  </Link>
                  {/* Volgende knop */}
                  {products.length > 1 && (
                    <button
                      className="absolute right-0 z-10 bg-white/80 hover:bg-accent1 text-accent1 hover:text-white rounded-full p-2 shadow transition"
                      style={{ top: '50%', transform: 'translateY(-50%)' }}
                      onClick={e => {
                        e.stopPropagation();
                        setCarouselIdx(arr => arr.map((v, i) => i === idx ? (v + 1) % products.length : v));
                      }}
                      aria-label="Volgende voorbeeld"
                    >
                      <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M9 5l7 7-7 7" /></svg>
                    </button>
                  )}
                </div>
                {/* Alleen naam klikbaar */}
                <Link to={`/categorie/${cat.id}`} style={{ textDecoration: 'none' }}>
                  <span className="text-base sm:text-lg font-bold mb-2 text-accent1 cursor-pointer">{product.name || cat.name}</span>
                </Link>
                <Link
                  to={`/categorie/${cat.id}`}
                  className="bg-grey bg-opacity-60 rounded px-4 py-2 text-sm sm:text-base font-medium border mt-2"
                  style={{ color: 'var(--color-text)', borderColor: 'var(--color-grey)' }}
                >
                  zie meer
                </Link>
              </div>
            );
          })}
        </div>
      </div>
      {/* 3D print service als aparte sectie */}
      <div className="container-custom section flex justify-center">
        <Link
          to="/3d-print-service"
          className="card w-full max-w-xl flex flex-col justify-center items-center hover:scale-105 transition-transform"
        >
          <span className="text-2xl font-bold mb-2 text-accent2">3D Print Service</span>
          <p className="text-center text-lg mb-4">
            Laat je eigen 3D-model professioneel printen en bezorgen door Prints by Jeroen.
          </p>
          <span className="btn-primary mt-auto">Meer info</span>
        </Link>
      </div>
      {/* Recensie-ticker onderaan homepage */}
      <div className="container-custom section">
        <h2 className="text-3xl font-extrabold mb-8 text-center text-accent1">Recensies</h2>
        <div style={{ width: '100%', overflow: 'hidden' }}>
          <div
            style={{
              display: 'flex',
              whiteSpace: 'nowrap',
              animation: 'marquee 40s linear infinite',
              gap: 32,
            }}
          >
            {homepageRecensies.map((r, i) => (
              <div key={i} className="card bg-white bg-opacity-90 rounded-xl shadow-lg p-6 border border-grey flex flex-col items-center min-w-[320px] mx-2" style={{ color: 'var(--color-text)' }}>
                <div className="flex items-center gap-2 mb-2">
                  <span className="font-bold text-accent1 text-lg">{r.naam}</span>
                  <span className="text-accent1">{'★'.repeat(r.sterren)}{'☆'.repeat(5 - r.sterren)}</span>
                </div>
                <div className="text-base text-center">{r.tekst}</div>
              </div>
            ))}
          </div>
          <style>{`
            @keyframes marquee {
              0% { transform: translateX(100%); }
              100% { transform: translateX(-100%); }
            }
          `}</style>
        </div>
        <div className="text-center mt-8">
          <a href="/recensies" className="btn-primary px-8 py-3 text-lg">Bekijk alle recensies</a>
        </div>
      </div>
    </div>
  );
} 